module.exports = __webpack_public_path__ + "img/wh.9201f300.jpg";